import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { getGarmentStock } from "../../services/GarmentStock/GarmentStock";
import SchedularModal from "../SchedularModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import useStoreGarmentStock from "../StoreContext/useStoreGarmentStock";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const StoreGarmentStock = () => {
  const navigate = useNavigate();

  const [storeGarmentStockData, setStoreGarmentStockData] = useState([]);
  const [storeGarmentStockSumData, setStoreGarmentStockSumData] = useState();

  const { storeData, userProfileData, brandProfileData } = getUserData();

  const storeId = storeData.id;
  let brandId = brandProfileData.id;
  let logInUserId = userProfileData.id;

  const {
    schedularDate,
    setSchedularDate,
  } = useStoreGarmentStock()

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  const fetchStoreGarmentStock = (data) => {
    setLoading(true);
    getGarmentStock(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const sortedCategoryList = response.data.sort((a, b) =>
            a.garmentName
              .toLowerCase()
              .localeCompare(b.garmentName.toLowerCase())
          );
          const totalSumData = sortedCategoryList.reduce(
            (acc, item) => acc + item.inProcess,
            0
          );
          setStoreGarmentStockData(sortedCategoryList);
          setStoreGarmentStockSumData(totalSumData);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      brandIds: [brandId], // brandId
      storeIds: [storeId], // storeId
      statusIn: [
        "BOOKED",
        "INPROCESS",
        "IN_WAREHOUSE",
        "OUT_FOR_DELIVERY",
        "PROCESSED",
        "DELAY",
      ],
      reportIds: [2], // brand report data id
      requestBy: logInUserId, // login userid
      reportGenerate: "false",
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(brandProfileData.createdDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date())),
    };
    fetchStoreGarmentStock(data);
  }, [schedularDate]);

  const renderAdminCardItem = () => {
    return storeGarmentStockData.map((item) => (
      <div className="flex-1 flex flex-row mx-2 justify-content-between">
        <div>
          <p className="flex-1 text-lg font-medium">
            {item.garmentName.replace(/_/g, " ")}
          </p>
        </div>
        <div>
          <p className="flex-1 text-lg font-medium ">{item.inProcess}</p>
        </div>
      </div>
    ));
  };

  const downloadPDF = (type) => {
    const doc = new jsPDF("portrait");
    const logoImg = new Image();

    // Set title of the document
    doc.setFontSize(20);
    doc.text(`STOCK`, 100, 20);

    // Format the table data from customerLedger
    const tableData = storeGarmentStockData.map((item) => {
      
      // Format the particulars based on ledgerMode
      return [
        item.garmentName.replace(/_/g, " "),
        item.inProcess
      ];
    });

    // Define table headers
    const tableHeaders = ["GARMENT NAME", `No. of Stock (${storeGarmentStockSumData})`];

    // Generate the table using autoTable
    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 25, // Start position for the table
      theme: "grid",
      styles: {
        fontSize: 10,
      },
    });

    // Handle either print or download based on the `type` argument
    if (type === "print") {
      // Create blob URL and open it in a new window for printing
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      let date = new Date();
      // Save as PDF file
      doc.save(
        `Stock_${Math.floor(date.getTime() + date.getSeconds() / 2)}`
      );
    }
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
              <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Stock
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 30 }}
            />
          </div>
          <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={() => downloadPDF("download")}
                src={"images/file.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={() => downloadPDF("print")}
                src={"Icons/printer.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="m-4">
          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Stock Data...</p>
            </div>
          ) : storeGarmentStockData.length > 0 ? (
            <div className="mx-2">
              <div className="flex flex-row py-1 mx-2 justify-content-between">
                <p className="flex-1 text-2xl font-bold ">Garment Name</p>
                <p className="flex-1 text-2xl font-bold text-right">
                  No. Of Stock ({storeGarmentStockSumData})
                </p>
              </div>
              {renderAdminCardItem()}
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Stock Found</p>
            </div>
          )}
        </div>
        <SchedularModal
            setSchedularModalVisible={setSchedularModalVisible}
            schedularModalVisible={schedularModalVisible}
            sendDataToOrdersPage={receiveDataFromSchedularModal}
            typeOfOrder={""}
            
          />
           
      </div>
    </div>
  );
};

export default StoreGarmentStock;
